export default __webpack_public_path__ + "static/media/blog.82805736.PNG";